module.exports = __webpack_public_path__ + "media/images/fallback_image-0428c2188d440d24ee36187fa828e86b.png";